import {SVGProps} from "react";

export function CheckCircleOne(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="m9 8.806l3.562 3.94a.788.788 0 0 0 1.206-.055L21 3"></path>
        <path d="M21 12a9 9 0 1 1-9-9"></path>
      </g>
    </svg>
  )
}
